import { Flex } from '@uhg-abyss/web/ui/Flex';
import React, { useEffect } from 'react';
import { useBreadcrumbs } from '@src/state/breadcrumbs';
import { PageLayout } from '@src/common/PageLayout';
import { styled } from '@uhg-abyss/web/tools/styled';
import { DataCard } from '@sde/widgets-core/src/common/DataCard';
import { PageBodyIntro } from '@workshop/common/PageBodyIntro';

const StyledContainer = styled('div', {
  marginTop: 30,
});

export const OptOut = () => {
  const { setBreadcrumbs, breadcrumbs } = useBreadcrumbs();

  useEffect(() => {
    setBreadcrumbs({
      id: 'opt-out',
      title: 'Opt Out',
      href: '/opt-out',
    });
  }, []);

  return (
    <React.Fragment>
      <PageBodyIntro title='Opt Out' breadcrumbs={breadcrumbs} />
      <PageLayout>
        <Flex>
          <Flex.Content>
            <StyledContainer>
              <DataCard
                title='Targeted Advertising and Analytics Tracking'
                configKey='opt-out-information'
              />
            </StyledContainer>
          </Flex.Content>
        </Flex>
      </PageLayout>
    </React.Fragment>
  );
};
